import styled from "@emotion/styled";

export const Title = styled.span(() => ({
    fontWeight: 700,
    fontSize: "20px",
}));

export const Description = styled.span(() => ({
    fontWeight: 400,
    fontSize: "16px",
}));
